import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-admins-validation',
    templateUrl: './admins-validation.component.svg',
    styleUrls: ['./admins-validation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminsValidationComponent {}
